import React from "react";
import { useInView } from "react-intersection-observer";

// CSS
import * as styles from "./OurStory.module.css";

const OurStoryComponent = props => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <>
      <div
        ref={ref}
        className={`container scroll_animate ${inView && "inview"} ${
          styles.diabConsLp__ourStory__cont
        }`}
      >
        <div className="row">
          <div className="col-12">
            <div className={styles.diabConsLp__ourStory__hdng}>
              <h3>{props.componentHeading}</h3>
            </div>
          </div>
        </div>
        <div className={`row ${styles.diabConsLp__ourStory__cardRow}`}>
          {props.diabetesConsultOurStory.map((data, index) => (
            <div key={index} className={`col-12 col-md-4 col-lg-4`}>
              <div className={styles.diabConsLp__ourStory__card}>
                <div className={`${styles.diabConsLp__ourStory__cardUpper}`}>
                  <p>{data.heading}</p>
                  <span className="icon">{data.icon}</span>
                </div>
                <div className={`${styles.diabConsLp__ourStory__cardlwr}`}>
                  <p>{data.text}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        {props.footerText ? (
          <div className="row">
            <div className="col-12">
              <div className={styles.diabConsLp__ourStory__footerTxt}>
                <p>{props.footerText}</p>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default OurStoryComponent;
